// v-dialogDrag: 弹窗拖拽+水平方向伸缩
import Vue from 'vue'
Vue.directive('dialogDrag', {
  inserted (el, binding, vnode, oldVnode) {
    // 弹框可拉伸最小宽高
    const minWidth = 400
    const minHeight = 300
    // 初始非全屏
    let isFullScreen = false
    // 当前顶部高度
    let nowMarginTop = 0
    // 获取弹框头部（这部分可双击全屏）
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    // 弹窗
    const dragDom = el.querySelector('.el-dialog')
    // 给弹窗加上overflow auto；不然缩小时框内的标签可能超出dialog；
    dragDom.style.overflow = 'auto'
    // 清除选择头部文字效果
    // dialogHeaderEl.onselectstart = new Function("return false");
    // 头部加上可拖动cursor
    dialogHeaderEl.style.cursor = 'move'
    // 获取原有属性 ie dom元素.currentStyle 火狐谷歌 window.getComputedStyle(dom元素, null);
    const sty = dragDom.currentStyle || window.getComputedStyle(dragDom, null)

    // 获取到的值带px 正则匹配替换
    let styL, styT, disX, disY, minDragDomLeft, maxDragDomLeft, minDragDomTop, maxDragDomTop
    let isMove = false
    // 鼠标按下
    const moveDown = e => {
      isMove = true
      const dragDomWidth = dragDom.offsetWidth
      const dragDomHeight = dragDom.offsetHeight

      const screenWidth = document.body.clientWidth
      const screenHeight = document.body.clientHeight

      // 鼠标按下，计算当前元素距离可视区的距离
      disX = e.clientX - dialogHeaderEl.offsetLeft
      disY = e.clientY - dialogHeaderEl.offsetTop

      minDragDomLeft = dragDom.offsetLeft
      maxDragDomLeft = screenWidth - dragDom.offsetLeft - dragDomWidth

      minDragDomTop = dragDom.offsetTop
      maxDragDomTop = screenHeight - dragDom.offsetTop - dragDomHeight
      // 注意在ie中 第一次获取到的值为组件自带50% 移动之后赋值为px
      if (sty.left.includes('%')) {
        styL = +document.body.clientWidth * (+sty.left.replace(/\%/g, '') / 100)
        styT = +document.body.clientHeight * (+sty.top.replace(/\%/g, '') / 100)
      } else {
        styL = +sty.left.replace(/\px/g, '')
        styT = +sty.top.replace(/\px/g, '')
      }
    }
    dialogHeaderEl.onmousedown = moveDown
    // 触屏，按下
    dialogHeaderEl.addEventListener('touchstart', e => {
      const clientX = e.changedTouches[0].clientX
      const clientY = e.changedTouches[0].clientY
      moveDown({ clientX, clientY })
    })

    // 鼠标移动
    const mousemove = (e) => {
      if (isMove) {
        // 通过事件委托，计算移动的距离
        let left = e.clientX - disX
        let top = e.clientY - disY

        // 边界处理
        if (-(left) > minDragDomLeft) {
          left = -minDragDomLeft
        } else if (left > maxDragDomLeft) {
          left = maxDragDomLeft
        }

        if (-(top) > minDragDomTop) {
          top = -minDragDomTop
        } else if (top > maxDragDomTop) {
          top = maxDragDomTop
        }
        // 移动当前元素
        dragDom.style.cssText += `;left:${left + styL}px;top:${top + styT}px;`
        // emit onDrag event
        vnode.child.$emit('dragDialog')
        // 将此时的位置传出去
        // binding.value({x:e.pageX,y:e.pageY})
      }
    }
    el.onmousemove = mousemove
    // 触屏移动
    el.addEventListener('touchmove', (e) => {
      if (isMove) {
        const clientX = e.changedTouches[0].clientX
        const clientY = e.changedTouches[0].clientY
        mousemove({ clientX, clientY })
      }
    })
    // 触屏离开
    el.addEventListener('touchend', () => {
      isMove = false
    })
    el.onmouseup = () => {
      isMove = false
    }

    // 双击头部全屏效果
    let nowWidth = 0 // 当前宽高
    dialogHeaderEl.ondblclick = e => {
      if (isFullScreen === false) {
        // nowHight = dragDom.clientHeight
        nowWidth = dragDom.clientWidth
        nowMarginTop = dragDom.style.marginTop
        dragDom.style.left = 0
        dragDom.style.top = 0
        dragDom.style.height = '100VH'
        dragDom.style.width = '100VW'
        dragDom.style.marginTop = 0
        isFullScreen = true
        dialogHeaderEl.style.cursor = 'initial'
        dialogHeaderEl.onmousedown = null
      } else {
        dragDom.style.height = 'auto'
        dragDom.style.width = nowWidth + 'px'
        dragDom.style.marginTop = nowMarginTop
        isFullScreen = false
        dialogHeaderEl.style.cursor = 'move'
        dialogHeaderEl.onmousedown = moveDown
      }
    }
  }
})
